<div class="panel rs-bg-grey2" *ngFor="let accessNumber of getNspKeys(); let i = index">
  <div class="rs-flex-row">
    <div class="rs-flex-column rs-flex-shrink">
      <p>
        <i class="icon-Connected-house icon-lh rs-txt-purple rs-txt-s7" aria-hidden="true"></i>
      </p>
    </div>
    <div class="rs-flex-column">
      <mprd-address
        [address]="nspValues[accessNumber].installationAddress"
        [showInOneLine]="true"
        [otherClass]="'rs-txt-purple rs-font-pxB'"
      ></mprd-address>
    </div>
  </div>
  <p
    *ngIf="nspValues[accessNumber].active"
    class="rs-status rs-status-ok"
    data-cy="nspInternetListActive"
  >
    <i class="rs-status-icon" aria-hidden="true"></i>{{ 'nsp.manage.status.active' | translate }}
  </p>

  <p *ngIf="nspValues[accessNumber].trialOption" data-cy="nspInternetListTrialOption">
    <span class="rs-txt-promo rs-font-pxB">{{
      'nsp.manage.trialOption.freeTrial' | translate
    }}</span>
    {{ 'nsp.manage.trialOption.until' | translate }}
    {{ nspValues[accessNumber].trialOption?.deactivationDate | date: 'dd MMMM yyyy' }}
  </p>
</div>
